import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MerchantRegistrationComponent } from './merchant-registration.component';

import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { Button } from 'primeng/button';

@NgModule({
  declarations: [],
  imports: [CommonModule, ReactiveFormsModule, BrowserModule, FormsModule, Button, MerchantRegistrationComponent],
  providers: [],
})
export class MerchantRegistrationModule {}
